import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ClipLoader } from 'react-spinners';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const now = new Date();
    const dateFormatter = new Intl.DateTimeFormat('pt-BR', {
      dateStyle: 'full',
      timeStyle: 'short'
    });
    const formattedDate = dateFormatter.format(now);

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      message: `Mensagem: ${formData.message}\n\nEmail do remetente: ${formData.email}`,
      to_email: 'contato@uniconn.com.br',
      subject: `Mensagem - Site (${formattedDate})`
    };

    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      templateParams,
      process.env.REACT_APP_EMAILJS_USER_ID
    )
    .then((response) => {
      setLoading(false);
      toast.success('Mensagem enviada com sucesso!', {
        autoClose: 3000 // Notificação exibida por 3 segundos
      });
      setFormData({ name: '', email: '', message: '' });
    }, (err) => {
      setLoading(false);
      toast.error('Falha ao enviar a mensagem.', {
        autoClose: 3000 // Notificação exibida por 3 segundos
      });
    });
  };

  return (
    <section id="contact" className="py-20 bg-gray-100 text-gray-800">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-10">Contato</h2>
        <div className="flex flex-col md:flex-row md:space-x-6">
          <div className="md:w-1/2 mb-6 md:mb-0">
            <h3 className="text-2xl font-bold mb-4">Entre em Contato</h3>
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div>
                <label className="block text-sm font-bold mb-2" htmlFor="name">Nome</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  className="w-full p-3 border border-gray-300 rounded-lg" 
                  placeholder="Seu nome" 
                  value={formData.name} 
                  onChange={handleChange} 
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-bold mb-2" htmlFor="email">Email</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  className="w-full p-3 border border-gray-300 rounded-lg" 
                  placeholder="Seu email" 
                  value={formData.email} 
                  onChange={handleChange} 
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-bold mb-2" htmlFor="message">Mensagem</label>
                <textarea 
                  id="message" 
                  name="message" 
                  className="w-full p-3 border border-gray-300 rounded-lg" 
                  placeholder="Sua mensagem" 
                  rows="5" 
                  value={formData.message} 
                  onChange={handleChange} 
                  required
                ></textarea>
              </div>
              <div className="flex justify-end">
                <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-full shadow-lg transform transition duration-500 hover:scale-105" disabled={loading}>
                  {loading ? <ClipLoader color={"#fff"} size={20} /> : 'Enviar'}
                </button>
              </div>
            </form>
          </div>
          <div className="md:w-1/2 mt-6 md:mt-0">
            <h3 className="text-2xl font-bold mb-4">Nosso Endereço</h3>
            <p className="mb-2">Praça Felix Guisard, 63 Centro Taubaté SP</p>
            <p className="mb-2">(12) 99114-9709</p>
            <p className="mb-2">contato@uniconn.com.br</p>

            <div className="h-96 w-full">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3675.8826528057354!2d-45.55856452503436!3d-22.963145445211486!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cc4b1d8370bb51%3A0x5a7a9d53f5d3b10!2sPra%C3%A7a%20Felix%20Guisard%2C%2063%2C%20Taubat%C3%A9%20-%20SP%2C%2012000-170%2C%20Brasil!5e0!3m2!1spt-BR!2sus!4v1625887103926!5m2!1spt-BR!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Google Maps"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
}

export default Contact;
